import type {
	BatchDeleteConsoleProfilesInput,
	ConsoleProfilesInput,
	CreateConsoleProfileInput,
	DeleteConsoleProfileInput,
	UpdateConsoleProfileInput,
} from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface KeyTypes {
	useGetAllConsoles: ConsoleProfilesInput;
	useCreateConsole: CreateConsoleProfileInput;
	useUpdateConsole: UpdateConsoleProfileInput;
	useDeleteConsole: DeleteConsoleProfileInput;
	useBatchDeleteConsoles: BatchDeleteConsoleProfilesInput;
}

const CONSOLE_SERVICE_KEYS = createReactQueryKeys<KeyTypes>("consoles", [
	"useGetAllConsoles",
	"useCreateConsole",
	"useUpdateConsole",
	"useDeleteConsole",
	"useBatchDeleteConsoles",
]);

export { CONSOLE_SERVICE_KEYS };
